import React from "react";
import Storyblok, { version } from "../../lib/storyblok-client";
import { relationsToResolve } from "@/constants/general";
import Components from "../../components/components";
import { generateEvents } from "@/lib/storyblok-gapi";
import { sortEventsByStartDate } from "@/components/Events/group-events-by-year";
import { getSeoFromStory } from "@/lib/seo";
import { useStoryblok } from "../../helpers/storyblok-hook";
import { isProduction } from "../../helpers/environment";
import { InferGetStaticPropsType } from "next";

type Props = InferGetStaticPropsType<typeof getStaticProps>;

export default function EventsIndex({ story, events }: Props) {
  story = useStoryblok(story, !isProduction);

  return (
    story &&
    React.createElement(Components(story?.content?.component), {
      key: story?.uuid,
      content: story?.content,
      published: story.published_at,
      events,
    })
  );
}

export async function getStaticProps() {
  try {
    const {
      data: { story },
    } = await Storyblok.get(`cdn/stories/events`, {
      resolve_relations: relationsToResolve,
      version,
    });

    const editorOrderedEvents = await generateEvents({
      eventItems: story?.content?.events_to_show || [],
    });
    // Grouped pages show events by start date; sort here too so the ItemList
    // structured data (built from this prop) matches the visible order.
    const events = story?.content?.group_by_year
      ? sortEventsByStartDate(editorOrderedEvents)
      : editorOrderedEvents;

    return {
      props: {
        story,
        events,
        seo: await getSeoFromStory({ story }),
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
